import { toast } from "react-toastify";
import { apiFormatForActiveServices } from "../Api/ApiFormat";
export const serviceCheckMainFunc = async (whom) => {
  try {
    let finaldata = await apiFormatForActiveServices(
      "/api/user/GetActiveService",
      ""
    );

    for (let i = 0; i < finaldata.data.length; i++) {
      if (finaldata.data[i].ServiceName === whom) {
        if (finaldata.data[i].IsActive === 1) {
          let data =
            sessionStorage.getItem("userId") +
            "/" +
            finaldata.data[i].ServiceName;
          let resp = await apiFormatForActiveServices(
            "/api/ServiceCheck/serviceCheckByUserIdAndServiceCode",
            data
          );

          if (resp.data !== "Block") {
            return "All good";
          } else {
            return "service blocked for you";
          }
        } else {
          return "service is down";
        }
      }
    }
  } catch (e) {
    toast.error(e.message);
  }
};
